import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

@Injectable({
  providedIn: 'root',
})
export class GtagService {
  // Not sure if i should extend Window to include dataLayer with an interface, using any for now because i can't access dataLayer otherwise
  constructor(@Inject(WINDOW) private window: any) {}

  pushEvent(event: any, isEcom = false): void {
    if (this.window?.dataLayer) {
      if (isEcom) {
        // Clears the previous ecommerce object to prevent recursive merge.
        this.window.dataLayer.push({ ecommerce: null });
      }
      this.window.dataLayer.push(event);
    }
  }
}
